<mat-toolbar class="toolbar-example">
    <span>Upload Excel</span>
    <span class="fill-remaining-space"></span>
    <mat-icon style="cursor: pointer;" (click)='onClose()'>close</mat-icon>
</mat-toolbar>

<div class="upload-dialog-content">
    <span>
        <a href="./assets/Candidate.xlsx" class="btn clss download-template" target="_self" 
        matTooltip="Download the excel/csv format for bulk upload" 
        download>
        CLICK HERE
        </a> to download the default format
    </span>
    
    <p>Upload your candidate data in the form of an <b>Excel spreadsheet </b>.</p>
</div>

<div class="actions-example">
    <button mat-raised-button class="btn-cancel" (click)='onClose()'>Cancel</button>
    <button mat-raised-button class="btn-color-example" style="margin-left: 10px;" (click)="csvInput.click()" matTooltip="Bulk upload for candidate through csv/excel">Upload Excel</button>
    <input #csvInput hidden="true" type="file" onclick="this.value=null" (change)="csvInputChange($event.target.files)" accept=".csv, .xls, .xlsx"/>

</div>